import { useEffect } from 'react';
import useUserStore from '@/store/user';
import useStore from '@/store/index';
import { getCache } from '@/hook/useCache';
import { CacheEnum } from '@/enum/cache';

/**
 * 用户数据刷新 Hook
 * 负责在页面刷新时重新获取用户数据和更新缓存
 */
export const useUserDataRefresh = () => {
  const { fetchUserDetails, fetchSubAccountList } = useUserStore();
  const { setLoginData } = useStore();

  useEffect(() => {
    const refreshUserData = async () => {
      try {
        // 1. 从缓存中获取用户ID和国家信息
        const cachedUserId = getCache({
          key: CacheEnum.userId,
          storage: localStorage,
        });
        const cachedCountry = getCache({
          key: CacheEnum.userCountry,
          storage: localStorage,
        });

        // 2. 如果缓存中有用户ID，重新获取用户数据
        if (cachedUserId) {
          // 3. 重新设置登录数据到store，这会同时更新缓存
          setLoginData({
            id: cachedUserId,
            country: cachedCountry,
          });

          // 4. 重新获取用户详情和菜单数据
          const success = await fetchUserDetails(cachedUserId, cachedCountry);

          if (success) {
            // 5. 重新获取子账号列表
            await fetchSubAccountList();
          } else {
            console.error('用户数据刷新失败');
          }
        } else {
          console.log('缓存中没有用户ID，跳过数据刷新');
        }
      } catch (error) {
        console.error('刷新用户数据时出错:', error);
      }
    };

    // 执行刷新逻辑
    refreshUserData();
  }, [fetchUserDetails, fetchSubAccountList, setLoginData]);
};
